<template>
  <div class="container" @click="_closeAll">
    <template v-if="status === 200 && channelInfo.id">
      <mobile></mobile>
    </template>
    <template v-else-if="status === 404">
      <status404></status404>
    </template>
    <template v-else-if="status === 408">
      <status408></status408>
    </template>
    <template v-else>
      <div class="loading"></div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import ROP from '@/utils/Rop'
const viewMobile = resolve => require(['@/components/view/index'], resolve)
const status404 = resolve => require(['@/components/view/404'], resolve)
const status408 = resolve => require(['@/components/view/408'], resolve)
export default {
  components: {
    mobile: viewMobile,
    status404: status404,
    status408: status408
  },
  data() {
    return {
      dmsTimer: null,
      id: this.$route.query.id
    }
  },
  head() {
    return {
      title: this.domTitle,
      style: []
    }
  },
  computed: {
    ...mapGetters({
      status: 'status',
      channelInfo: 'channelInfo'
    }),
    domTitle() {
      if (this.status === 200) {
        return this.channelInfo.title || ''
      } else if (this.status === 404) {
        return '抱歉，您的页面迷路了'
      } else if (this.status === 408) {
        return '直播间人数较多，请耐心等待'
      } else {
        return this.channelInfo.title || ''
      }
    },
    dmsTopic() {
      return {
        pic_text: `pic_text_${this.channelInfo.id}`,
        pic_text_live: `pic_text_live_${this.channelInfo.uin}`
      }
    }
  },
  watch: {
    'channelInfo.uin'() {
      this.get_userInfo()
    },
    domTitle() {
      document.title = this.domTitle
    }
  },
  async created() {
    // REPORT($sentry, { AppId: query.id, Uin: query.uin })
    await this.$store.dispatch('get_control', { id: this.$route.query.id })
  },
  async mounted() {
    document.title = this.domTitle;
    this.get_globalSetting()
    if (this.status !== 200) {
      return false
    }
    this.set_corpId(this.$route.query.corpId)
    this._DMSInit()
    this._enterDms()
  },
  methods: {
    ...mapMutations({
      set_corpId: 'set_corpId'
    }),
    ...mapActions({
      get_userInfo: 'get_userInfo',
      get_globalSetting: 'get_globalSetting'
    }),
    _closeAll() {
      this.$Bus.$emit('bus-remEnclosure')
    },
    _enterDms() {
      clearTimeout(this.dmsTimer)
      this.dmsTimer = null
      this.dmsTimer = setTimeout(() => {
        this._makeClientId()
        this.dmsTimer = null
      }, 500)
    },
    _makeClientId() {
      ROP.Leave()
      const uin = this.channelInfo.uin || '0'
      const channelId = this.channelInfo.id || '0'
      const timeStr = String(
        new Date().getTime() + Math.floor(Math.random() * 100000)
      )
      const clientId = `${uin}_${channelId}_${timeStr}`
      console.log(clientId)
      ROP.Enter('', this.channelInfo.sub_key, clientId, true)
    },
    _DMSInit() {
      const self = this
      // chat连接成功后的消息
      ROP.On('enter_suc', function () {
        console.log('服务器连接成功')
        const dmsTopic = self.dmsTopic
        ROP.Subscribe(dmsTopic.pic_text)
        ROP.Subscribe(dmsTopic.pic_text_live)
      })
      ROP.On('reconnect', function (err) {
        console.log('重连', err)
      })
      // chat连接失败后的消息
      ROP.On('enter_fail', function (err) {
        console.log('服务器连接失败', err)
      })
      // chat接收到的消息
      ROP.On('publish_data', function (res, topic) {
        const data = JSON.parse(res)
        const dmsTopic = self.dmsTopic
        switch (topic) {
          case dmsTopic.pic_text:
            self.$Bus.$emit('bus-reportAdd', data)
            break
          case dmsTopic.pic_text_live:
            if (Number(data.id) === Number(self.channelInfo.id)) {
              switch (data.cmd) {
                case 'viewCount':
                  self.$Bus.$emit('bus-viewCount', data)
                  break
                case 'starCount':
                  self.$Bus.$emit('bus-starCount', data.starCount)
                  break
                case 'commentPass':
                  // 为0时是聊天评论，不是图文评论
                  if(data.data.reportId === 0){
                    self.$Bus.$emit('bus-addChat', data.data)
                  }
                  break
                case 'commentDelete':
                  self.$Bus.$emit('bus-delChat', data.data.id)
                  break
                default:
                  break
              }
            }
            break
          default:
            break
        }
      })
      // chat断开连接后的消息
      ROP.On('losed', function () {
        console.log('服务器断开连接')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100vh;
    background-color: #fbfbfb;
    background-image: url("~@/assets/img/loading.gif");
    background-repeat: no-repeat;
    background-size: 270px auto;
    background-position: center center;
  }
}
</style>
